import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import React, { Fragment } from 'react';
import { useTheme } from 'styled-components';
import { getFundClassName, getFundClass, getProductManager, getFundsSheetPath } from '@finect/front-resources/Products';
import { Section } from '../../Section';
import { LastQuote } from '../../Products/LastQuote';
import { getProductTypeByAPISubtype, getPeriodPerformance } from '../../Products/utils';
import { InfoLabel } from '../../Products/InfoLabel';
import { Rating } from '../../Rating';
import { DateLabel } from '../../DateLabel';
import { ManagerLabel } from './ManagerLabel';
import { Info, Title, QuotesContainer, SubtitleSimple, Subtitle, SubtitleISIN, SubtitleClassname, ScoreBlock, InfoLabelsBlock, ReviewLink } from './partials';
var getWriteReviewPath = function getWriteReviewPath(productType, product) {
  return "".concat(productType.slug, "/").concat(product.isin, "-").concat(product.alias, "/reviews/nueva-review");
};
var handleRating = function handleRating(productType, fund, theme) {
  if (!theme.partner.user.actions) {
    return;
  }
  window.location.href = getWriteReviewPath(productType, fund);
};
var clickNav = function clickNav(hash) {
  if (hash && typeof hash === 'string') {
    var element = document.getElementById(hash);
    element && element.scrollIntoView({
      behavior: 'smooth'
    });
  }
};
var SecurityHeader = function SecurityHeader(_ref) {
  var fund = _ref.fund,
    product = _ref.product,
    bottomMargin = _ref.bottomMargin,
    _ref$withReviews = _ref.withReviews,
    withReviews = _ref$withReviews === void 0 ? true : _ref$withReviews,
    _ref$withPerformances = _ref.withPerformances,
    withPerformances = _ref$withPerformances === void 0 ? true : _ref$withPerformances,
    simple = _ref.simple,
    isPartner = _ref.isPartner;
  var theme = useTheme();
  var productType = getProductTypeByAPISubtype(fund.subtype, theme);
  var _theme$partner$produc = theme.partner.productsFeatures,
    productsFeatures = _theme$partner$produc === void 0 ? ['rating'] : _theme$partner$produc;
  var performance = {
    M0: getPeriodPerformance(fund.stats, 'M0', 'accumulated'),
    M12: getPeriodPerformance(fund.stats, 'M12', 'accumulated'),
    M36: getPeriodPerformance(fund.stats, 'M36', 'annualized')
  };
  var fundClass = getFundClass(fund);
  var currency = fundClass ? fundClass.currency : null;
  var lastPrice = fund.lastQuote ? fund.lastQuote.price : 0;
  var totalReviews = product && product.entity ? product.entity.socialStats.reviews.total : 0;
  var ratingProvider = productsFeatures.find(function (feature) {
    return feature.includes('rating-');
  }) || 'rating-finect';
  var rating = ratingProvider && fund.ratings.find(function (item) {
    return item.provider === ratingProvider.replace('rating-', '');
  }) || {
    value: fund.score
  };
  var manager = getProductManager(product);
  var productPath = getFundsSheetPath(theme, productType, fund);
  var minPhablet = typeof window !== 'undefined' ? window.innerWidth >= 640 : false;
  return React.createElement(React.Fragment, null, manager ? React.createElement(ManagerLabel, {
    manager: manager,
    isPartner: isPartner
  }) : null, React.createElement(Section, {
    bottomMargin: bottomMargin || false
  }, React.createElement(Info, null, React.createElement("div", null, React.createElement(Title, {
    as: theme.partner.headings.title
  }, getFundClassName(fund)), simple ? React.createElement(SubtitleSimple, null, React.createElement(LastQuote, {
    align: "left",
    primary: true,
    value: lastPrice,
    currency: currency === null || currency === void 0 ? void 0 : currency.code
  }), React.createElement(SubtitleISIN, null, "Fecha de ", minPhablet ? 'actualización ' : '', "valor liquidativo:", ' ', fund.lastQuote.datetime ? React.createElement(DateLabel, {
    date: new Date(fund.lastQuote.datetime),
    format: "L"
  }) : '')) : React.createElement(Subtitle, null, React.createElement(SubtitleISIN, null, fund.isin), !['plan'].includes(productType.id) ? React.createElement(React.Fragment, null, React.createElement(SubtitleISIN, null, ' · '), React.createElement(SubtitleClassname, null, getFundClassName(fund))) : null), productsFeatures.includes('rating') ? React.createElement(ScoreBlock, null, React.createElement(Rating, {
    starColorHover: "gold",
    starColor: "gold",
    starSize: minPhablet ? '20px' : '16px',
    value: rating.value || 0,
    max: 5,
    isSelectable: true,
    type: "star",
    onChange: function onChange() {
      return handleRating(productType, fund, theme);
    }
  }), withReviews ? !totalReviews ? React.createElement(React.Fragment, null, theme.partner.user.actions ? React.createElement(ReviewLink, {
    rel: "nofollow",
    href: getWriteReviewPath(productType, fund),
    "data-fi-event": "product-header"
  }, "S\xE9 el primero en opinar") : null) : React.createElement(ReviewLink, {
    onClick: function onClick() {
      return clickNav('opiniones');
    },
    "data-fi-event": "product-header"
  }, "Ver ", totalReviews, " ", totalReviews === 1 ? 'opinión' : 'opiniones') : null) : null), React.createElement(QuotesContainer, null, !simple ? React.createElement(LastQuote, {
    value: lastPrice,
    currency: currency === null || currency === void 0 ? void 0 : currency.code,
    label: React.createElement(DateLabel, {
      date: fund.lastQuote.datetime ? new Date(fund.lastQuote.datetime) : '',
      format: "L"
    }),
    bottomMargin: true
  }) : null, withPerformances && React.createElement(InfoLabelsBlock, null, React.createElement(InfoLabel, {
    value: performance.M0 ? performance.M0.value : null,
    unit: "percent",
    label: "".concat(performance.M0 ? new Date(performance.M0.date).getFullYear() : new Date().getFullYear(), " \u20AC"),
    tooltip: {
      tip: 'Rentabilidad en el año',
      from: 'right'
    }
  }), React.createElement(InfoLabel, {
    value: performance.M36 ? performance.M36.value : null,
    unit: "percent",
    label: "3A \u20AC",
    tooltip: {
      tip: 'Rentabilidad anualizada a 3 años',
      from: 'right'
    }
  }))))));
};
export default SecurityHeader;